import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all users
export const fetchUsers = createAsyncThunk("users/fetchUsers", async ({page=1,search = ""}) => {
  try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
    const token = user?.token;
    const response = await axios.get(
      `${BASE_URL}/dashboard/users?page=${page}&search=${search}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Failed load data";
    return message;
  }
});

// add users
export const addUser = createAsyncThunk(
  "users/add",
  async (data, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/users`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );

      const createdUser = response.data?.data;
      const statusValue = data.get ? data.get("status") : data.status;

      // لو تم اختيار حالة "غير نشط" (0)، نرسل طلب تحديث فوري لتغيير الحالة بالـ ID الراجع
      if (createdUser?.id && statusValue === "0") {
        const updateData = new FormData();
        updateData.append("status", "0");

        await axios.post(
          `${BASE_URL}/dashboard/users/${createdUser.id}/update`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
              "Accept-Language": "ar",
            },
          }
        );
      }

      return { ...response.data, message: "تمت الإضافة بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إضافة المستخدم";
      return rejectWithValue(message);
    }
  }
);
// get users record
export const usersRecord = createAsyncThunk(
  "users/usersRecord",
  async (id, { rejectWithValue }) => {
    try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/users/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل بيانات المستخدم";
      return rejectWithValue(message);
    }
  }
);

// get full user details (activity, orders, wallet, etc.)
export const fetchUserDetails = createAsyncThunk(
  "users/fetchUserDetails",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/users/${id}/details`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل تفاصيل المستخدم";
      return rejectWithValue(message);
    }
  }
);
// update users
export const updateUsers = createAsyncThunk(
  "users/updateUsers",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/users/${id}/update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تم التحديث بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحديث المستخدم";
      return rejectWithValue(message);
    }
  }
);
// delete user
export const deleteUsers = createAsyncThunk(
  "users/deleteUsers",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.delete(
        `${BASE_URL}/dashboard/users/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف المستخدم";
      return rejectWithValue(message);
    }
  }
);
const UsersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    record: null,
    userDetails: null,
    meta: null,
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.meta = action.payload.meta;
        state.users = action.payload.data;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      .addCase(addUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(usersRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(usersRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(usersRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(fetchUserDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.userDetails = null;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userDetails = action.payload.data;
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load user details";
      })
      .addCase(updateUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(updateUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(deleteUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteUsers.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from users array
        if (Array.isArray(state.users)) {
          state.users = state.users.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.success = action.payload?.message || "Deleted successfully";
      })
      .addCase(deleteUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete users";
      });
  },
});

export const { clearState } = UsersSlice.actions;
export default UsersSlice.reducer;
